import { render, staticRenderFns } from "./SearchBar.component.vue?vue&type=template&id=35654d30&scoped=true"
import script from "./SearchBar.component.vue?vue&type=script&lang=ts"
export * from "./SearchBar.component.vue?vue&type=script&lang=ts"
import style0 from "./SearchBar.component.vue?vue&type=style&index=0&id=35654d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35654d30",
  null
  
)

export default component.exports